var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C9 0.447715 8.55229 0 8 0C7.44772 0 7 0.447715 7 1V5.66667C7 6.40305 6.40305 7 5.66667 7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H5.66667C6.40305 9 7 9.59695 7 10.3333V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V10.3333C9 9.59695 9.59695 9 10.3333 9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H10.3333C9.59695 7 9 6.40305 9 5.66667V1Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGrey);
export default __webpack_public_path__ + "static/media/add_grey.8ce5f8b1fda681124521bcab3a194d1b.svg";
export { ForwardRef as ReactComponent };